import type { TextFieldProps } from '@mui/material';
import { Input } from '@/shared/ui';
import {
  getError,
  URLValidatonErrorCode,
} from '../AddWebLinkRow/useAddWebLinkFields';

export function URLInput(props: TextFieldProps) {
  const errorMessage = props.error
    ? getErrorMessage(props.value as string)
    : '';

  return (
    <Input
      sx={{
        '& .MuiFormHelperText-root': {
          mt: 0,
          mx: 1.5,
        },
      }}
      label="URL"
      helperText={errorMessage}
      {...props}
    />
  );
}

const getErrorMessage = (value: string): string => {
  if (!value) {
    return '';
  }

  const error = getError(value)!;

  switch (error.code) {
    case URLValidatonErrorCode.includesProtocol:
      return 'Should not include protocol.';
    case URLValidatonErrorCode.invalidURL:
    default:
      return 'Invalid URL.';
  }
};
